import { Link } from "react-router-dom";
import AppStoreButton from "@/components/AppStoreButton";
import { Wordmark } from "@/components/Nav";
import { FadeUp, MaskedLines, Eyebrow } from "@/components/Reveal";
import SilkTexture, { SILK } from "@/components/SilkTexture";
import { EMAILS } from "@/config";

const COLUMNS = [
  {
    title: "Deneyim",
    links: [
      { to: "/nasil-calisir", label: "Nasıl Çalışır" },
      { to: "/the-five", label: "The Five" },
      { to: "/konsiyerj", label: "Çöpçatan Deneyimi" },
      { to: "/my-date", label: "My Date" },
    ],
  },
  {
    title: "Kulüp",
    links: [
      { to: "/uyelik", label: "Üyelik" },
      { to: "/sss", label: "SSS" },
      { to: "/support", label: "Destek" },
      { to: "/contact", label: "İletişim" },
    ],
  },
  {
    title: "Yasal",
    links: [
      { to: "/privacy", label: "Gizlilik" },
      { to: "/terms", label: "Kullanım Koşulları" },
      { to: "/account-deletion", label: "Hesap Silme" },
      { to: "/gizlilik", label: "Gizlilik Politikası" },
      { to: "/kvkk", label: "KVKK Aydınlatma Metni" },
      { to: "/kullanim-kosullari", label: "Kullanım Koşulları" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-ivory relative overflow-hidden">
      <SilkTexture src={SILK.flow} side="right" opacity={0.2} speed={40} blend="screen" className="h-[70vh]" />
      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="py-20 sm:py-28 text-center border-b border-ivory/10">
          <FadeUp>
            <Eyebrow light className="justify-center">Five Star · Concierge Dating</Eyebrow>
          </FadeUp>
          <h2 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight">
            <MaskedLines lines={["Tanışmanın daha", <em key="i" className="italic text-rose-soft">kişisel hali.</em>]} />
          </h2>
          <FadeUp delay={0.25} className="mt-10 flex flex-col items-center gap-5">
            <AppStoreButton variant="light" testid="footer-appstore-button" />
            <p className="text-xs text-ivory/50 tracking-wide">18+ · Yalnızca yetişkinler içindir</p>
          </FadeUp>
        </div>

        <div className="py-16 grid gap-12 sm:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Wordmark light />
            <p className="mt-6 max-w-xs text-sm font-light text-ivory/60 leading-relaxed">
              Sonsuz profiller değil; sana özel seçilen eşleşmeler, çöpçatan desteği ve geri bildirimle şekillenen kişisel bir dating deneyimi.
            </p>
            <div className="mt-8 space-y-2 text-sm">
              <a data-testid="footer-email-hello" href={`mailto:${EMAILS.hello}`} className="block text-ivory/70 hover:text-rose-soft transition-colors">
                {EMAILS.hello}
              </a>
              <a data-testid="footer-email-support" href={`mailto:${EMAILS.support}`} className="block text-ivory/70 hover:text-rose-soft transition-colors">
                {EMAILS.support}
              </a>
            </div>
          </div>
          {COLUMNS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-gold">{col.title}</p>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.to.slice(1)}`}
                      className="text-sm font-light text-ivory/70 hover:text-ivory transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="py-8 border-t border-ivory/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-ivory/50">© Five Star. Tüm hakları saklıdır.</p>
          <span
            data-testid="footer-age-badge"
            className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-gold/50 text-gold text-xs font-cinzel font-semibold"
          >
            18+
          </span>
        </div>
      </div>
    </footer>
  );
}
